import React from 'react';

export function useTitleForOverflowContent(contentRef: React.MutableRefObject<HTMLElement>) {
    setTimeout(() => {
        if (contentRef.current) {
            const contentElement = contentRef.current;
            const contentParentElement = contentElement.parentElement;
            const shouldApplyTitle = contentElement.getBoundingClientRect().height > contentParentElement.getBoundingClientRect().height;
            contentElement.setAttribute('title', shouldApplyTitle ? contentElement.innerText : '');
        }
    });
}